import React, { useEffect } from 'react';
import breakpoints from 'Exports/breakpoints.scss';
import useWindowSize from './useWindowSize';

const MOBILE_BREAKPOINT = 'large'; // below large = mobile

const useIsMobile = (breakpoint = MOBILE_BREAKPOINT) => {
  breakpoint = parseInt(breakpoints[breakpoint].replace('px', ''));

  const [windowWidth] = useWindowSize();
  const [isMobile, setIsMobile] = React.useState(windowWidth <= breakpoint - 1);

  useEffect(() => {
    setIsMobile(windowWidth <= breakpoint - 1);
  }, [windowWidth, breakpoint]);

  return isMobile;
};

export default useIsMobile;
